import { HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { FileSearchQuery, FileUploadModel, Upload } from '@shared/interfaces';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileUploadsService {
  constructor(private restApiService: RestapiService) {}

  uploadFile(file: File): Observable<Upload> {
    return this.restApiService.upload<Upload>(`FileUploads/`, file);
  }

  uploadFileProgress(file: File): Observable<HttpEvent<any>> {
    return this.restApiService.uploadProgress(`FileUploads/`, file);
  }

  removeFile(fileId: number): Observable<boolean> {
    return this.restApiService.delete<boolean>(`FileUploads/${fileId}`);
  }

  search(query: FileSearchQuery) {
    return this.restApiService.post<FileUploadModel[]>(`FileUploads/search`, query);
  }

  download(fileUploadId: number) {
    this.search({ ids: [fileUploadId] }).subscribe(result => {
      if (result?.length) {
        window.open(result[0].cloudUri, '_parent');
      }
    });
  }
}
